exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__item___3Upok {\n  display: flex;\n  width: 100%;\n  font-size: 15px;\n  height: 50px;\n  align-items: center; }\n  .style__item___3Upok > label:first-child {\n    display: flex; }\n\n.style__itemGroup___lHWyY {\n  width: 100%;\n  overflow-x: hidden; }\n", ""]);

// exports
exports.locals = {
	"item": "style__item___3Upok",
	"itemGroup": "style__itemGroup___lHWyY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/SingleColorSelector/MobileDropdownSelect/SingleSelectModal/style.scss
// module id = 2148
// module chunks = 6